const triggers = document.querySelectorAll('[data-nav-toggle]');
const panel = document.querySelector('.mobile-nav-wrapper');
const container = document.querySelector('.site-container');

triggers.forEach(element => {
	element.addEventListener('click', handleClick);
});

function handleClick(event) {
	// 'event' represents the click event in this case which has a ton
	// attached to the API https://developer.mozilla.org/en-US/docs/Web/API/Event
	// We mostly use preventDefault and currentTarget (that's the actual DOM element that)
	// was clicked. I sometimes simply call this 'e' for event.
	// Another thing you'll see me do is extract parts out of the event directly
	// as a constant
	// e.g. const { currentTarget } = event;
	// in this particular case that would be the [data-nav-toggle] element

	event.preventDefault();
	panel.classList.toggle('is-visible');
	container.classList.toggle('is-visible');

	triggers.forEach(element => {
		element.classList.toggle('is-active');
	});
}
